
import Matchup from "@/shared/matchups/matchup";
import Owner from "@/shared/owners/owner";
import OwnerTeam from "@/shared/teams/owner-team";
import TitleBeltHolder from '@/shared/title-belts/title-belt-holder';
import TitleBelt, { WinnersDictionary } from '@/shared/title-belts/title-belt';
import { ref } from "vue";
import Season from "@/shared/seasons/season";
import Team from "@/shared/teams/team";
import { useRouter } from "vue-router";
import { orderBy } from 'lodash';
import { useStore } from 'vuex';
import { watch } from 'vue';
function getTitleBeltHistory(seasons: Season[]) {
  const ownerTeams: OwnerTeam[] = [];
  const titleBeltHistory: TitleBeltHolder[] = [];
  let memberCount = 1;

  function getOwnerTeam(ownerTeams: OwnerTeam[], id: number, season: number): OwnerTeam {
    const baseOwnerTeam: OwnerTeam = {
      id: 0,
      owner: {
        id: "0",
        firstName: "BYE",
        lastName: "WEEK",
      },
      teams: [],
      teamYears: [],
      experience: 0,
    };

    if (id === 0) {
      return baseOwnerTeam;
    }

    for (let i = 0; i < ownerTeams.length; i++) {
      const ownerTeam: OwnerTeam = ownerTeams[i];
      const teamYear = ownerTeam.teamYears && ownerTeam.teamYears.find((teamYear) => {
        return teamYear.year === season && teamYear.team === id;
      });

      if (teamYear) return ownerTeam;
    }

    return baseOwnerTeam;
  }

  function isOwnerInMatchup(ownerTeam: TitleBeltHolder, matchup: Matchup, seasonId: number, teamSide: 'home' | 'away') {
    if (!ownerTeam) return false;
    return ownerTeam.teamYears && ownerTeam.teamYears.some(
      (teamYear) =>
        teamYear.year === seasonId &&
        matchup[teamSide] &&
        teamYear.team === matchup[teamSide].teamId
    );
  }

  function isOwnerInSeason(ownerTeam: TitleBeltHolder, seasonId: number) {
    if (!ownerTeam) return false;
    return ownerTeam.teamYears && ownerTeam.teamYears.some(
      (teamYear) =>
        teamYear.year === seasonId
    );
  }


  function getMatchupScores(
    matchup: Matchup,
    teamSide: 'home' | 'away',
    season: Season
  ) {
    if (matchup.winner === teamSide.toUpperCase() || matchup.winner === 'TIE') {
      const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup[teamSide].teamId, season.seasonId);
      const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
      titleBeltHistory.push(titleBeltHolder);
    } else if (matchup.winner !== "UNDECIDED") {
      if (teamSide === 'home') {
        const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['away'].teamId, season.seasonId);
        const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
        titleBeltHistory.push(titleBeltHolder);
      } else { 
        const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['home'].teamId, season.seasonId);
        const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
        titleBeltHistory.push(titleBeltHolder); 
      }
    }
  }

  function getHighestScorerForWeek(season: Season, week: number): TitleBeltHolder {
    let weeklyHighScore = 0;
    let weeklyHighScorer: TitleBeltHolder = {
      week: week,
      season: season.seasonId,
      count: 1,
      owner: {
        firstName: 'default',
        lastName: 'name',
      }
    };

    for (let i = 0; i < season.schedule.length; i++) {
      const matchup: Matchup = season.schedule[i];
      if (matchup.matchupPeriodId !== week) {
        continue;
      }

      if (matchup.home.totalPoints > weeklyHighScore) {
        weeklyHighScore = matchup.home.totalPoints;
        weeklyHighScorer = { ...getOwnerTeam(ownerTeams, matchup.home.teamId, season.seasonId), week: week, season: season.seasonId, count: 1 };
      }

      if (matchup.away.totalPoints > weeklyHighScore) {
        weeklyHighScore = matchup.away.totalPoints;
        weeklyHighScorer = { ...getOwnerTeam(ownerTeams, matchup.away.teamId, season.seasonId), week: week, season: season.seasonId, count: 1 };
      }
    }

    return weeklyHighScorer;
  }

  for (let i = 0; i < seasons.length; i++) {
    const season = seasons[i];

    for (let k = 0; k < season.members.length; k++) {
      const member: Owner = season.members[k];

      if (!ownerTeams.some((x) => x.owner && x.owner.id === member.id)) {
        memberCount++;
        const ownerTeam: OwnerTeam = {
          id: memberCount,
          currentSeasonGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          recentGames: {
            pointsFor: 0,
            pointsAgainst: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            matchupCount: 0,
          },
          matchupHistory: [],
          owner: member,
          teams: [],
          teamYears: [],
          highScore: {
            points: 0,
          },
          lowScore: {
            points: 500,
          },
          championshipYears: [],
          playoffYears: [],
          playoffWins: 0,
          experience: 0,
        };
        ownerTeams.push(ownerTeam);
      }
    }
  }

  for (let i = 0; i < seasons.length; i++) {
    const season: Season = seasons[i];

    for (let j = 0; j < season.teams.length; j++) {
      const team: Team = season.teams[j];

      for (let i = 0; i < ownerTeams.length; i++) {
        const ownerTeam: OwnerTeam = ownerTeams[i];
        if (ownerTeam.owner && team.owners && ownerTeam.owner.id === team.owners[0] && ownerTeam.teams && ownerTeam.teamYears) {
          ownerTeam.teams.push(team);
          if (team.id) {
            ownerTeam.teamYears.push({ year: season.seasonId, team: team.id });
          }
        }
      }
    }

    if (i === 0) {
      for (let index = season.schedule.length - 1; index > 0; index--) {
        const matchup: Matchup = season.schedule[index];
        if (matchup.playoffTierType === 'WINNERS_BRACKET') {
          if (matchup.winner === 'AWAY') {
            const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['away'].teamId, season.seasonId);

            const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
            titleBeltHistory.push(titleBeltHolder);
          } else if (matchup.winner === 'HOME') {
            const currentTeam: OwnerTeam = getOwnerTeam(ownerTeams, matchup['home'].teamId, season.seasonId);
            const titleBeltHolder: TitleBeltHolder = { ...currentTeam, week: matchup.matchupPeriodId, season: season.seasonId, count: 1 }
            titleBeltHistory.push(titleBeltHolder)
          }

          break;
        }
      }
    } else {  
      let needsNewTitleBeltHolder = false;
      let newTitleBeltHolderAdded = false;
      if (!isOwnerInSeason(titleBeltHistory[titleBeltHistory.length - 1], season.seasonId)) {
        needsNewTitleBeltHolder = true;
      }

      for (let matchupIndex = 0; matchupIndex < season.schedule.length; matchupIndex++) {
        const matchup: Matchup = season.schedule[matchupIndex];

        if (needsNewTitleBeltHolder && matchup.matchupPeriodId === 1) {
          if (!newTitleBeltHolderAdded) {
            const newBeltHolder: TitleBeltHolder = getHighestScorerForWeek(season, matchup.matchupPeriodId);
            titleBeltHistory.push(newBeltHolder);
            newTitleBeltHolderAdded = true;
          }
          continue;
        } else if (needsNewTitleBeltHolder && matchup.matchupPeriodId !== 1) {
          needsNewTitleBeltHolder = false;
          newTitleBeltHolderAdded = false;
        }

        if (isOwnerInMatchup(titleBeltHistory[titleBeltHistory.length - 1], matchup, season.seasonId, "away")) {
          getMatchupScores(matchup, "away", season);
        } else if (isOwnerInMatchup(titleBeltHistory[titleBeltHistory.length - 1], matchup, season.seasonId, "home")) { 
          getMatchupScores(matchup, "home", season);
        }
      }
    }
  }

  return titleBeltHistory.reverse();
}

function gettitleBelt(titleBeltHolders: TitleBeltHolder[]): TitleBelt {
  const titleBelt: TitleBelt = {
    longestStreak: {
      owners: [],
      count: 0,
    },
    winners: []
  }

  const winners: WinnersDictionary = {};

  let currentStreak = 0;
  for (let i = 0; i < titleBeltHolders.length; i++) {
    const winner: TitleBeltHolder = titleBeltHolders[i];

    if (i === 0) {
      titleBelt.longestStreak.owners.push(winner);
      currentStreak++;
      titleBelt.longestStreak.count = currentStreak;
    } else {
      const previousHolder = titleBeltHolders[i-1];
      if (winner.owner && previousHolder && previousHolder.owner && winner.owner.id === previousHolder.owner.id) {
        currentStreak++;
        
        if (currentStreak > titleBelt.longestStreak.count) {
          titleBelt.longestStreak.owners = [];
          titleBelt.longestStreak.owners.push(winner);
          titleBelt.longestStreak.count = currentStreak;
        } else if (currentStreak === titleBelt.longestStreak.count) {
          titleBelt.longestStreak.owners.push(winner);
        } 
      } else {
        currentStreak = 1;
      }
    }

    const winnerProfile = winner.owner && winner.owner.id && winners[winner.owner.id];

    if (winnerProfile) {
      winnerProfile.count++;
    } else if (winner.owner && winner.owner.id) {
      winners[winner.owner.id] = {
        owner: winner.owner,
        count: 1,
        week: winner.week,
        season: winner.season,
      }
    }
  }

  titleBelt.winners = orderBy(winners, ["count"], ["desc"]);

  return titleBelt;
}

function useHistory() {
  const selectedTeam = ref<Team>();
  const titleBeltHistory = ref<Array<TitleBeltHolder>>();
  const titleBelt = ref({});
  const router = useRouter();
  const store = useStore();

  async function getLeagueHistory() {
    titleBeltHistory.value = getTitleBeltHistory(store.state.league);
    titleBelt.value = gettitleBelt(titleBeltHistory.value);
  }

  watch(
    () => store.state.leagueId, 
    () => {
      titleBeltHistory.value = [];
      titleBelt.value = {};
      getLeagueHistory();
    }
  )

  watch(
    () => store.state.league, 
    () => {
      titleBeltHistory.value = [];
      titleBelt.value = {};
      getLeagueHistory();
    }
  )

  getLeagueHistory();

  return { router, selectedTeam, titleBeltHistory, titleBelt };
}

export default {
  setup() {
    return useHistory();
  },
};
